const hasOwn = {}.hasOwnProperty;

function appendClass(value, newClass) {
  if (!newClass) {
    return value;
  }

  return value ? value + ' ' + newClass : newClass;
}

export default function classnames(...classes) {
  let resultClasses = '';
  classes.forEach((current) => {
    if (typeof current === 'object') {
      let classes = '';
      for (const key in current) {
        if (hasOwn.call(current, key) && current[key]) {
          classes = appendClass(classes, key);
        }
      }
      resultClasses += `${classes} `;
    } else {
      resultClasses += `${current} `;
    }
  });

  return resultClasses;
}
